var _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 672,
    viewBox: "0 0 622 672",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 286.115,
    cy: 336,
    r: 335.19,
    stroke: "url(#paint0_linear_6169_4405)",
    strokeWidth: 1.39083,
    strokeDasharray: "27.82 27.82"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.42,
    cy: 335.305,
    r: 262.322,
    stroke: "url(#paint1_linear_6169_4405)",
    strokeWidth: 1.08847,
    strokeDasharray: "21.77 21.77"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.506,
    cy: 337.391,
    r: 192.231,
    stroke: "url(#paint2_linear_6169_4405)",
    strokeWidth: 0.797639,
    strokeDasharray: "15.95 15.95"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.684,
    cy: 335.305,
    r: 130.467,
    stroke: "url(#paint3_linear_6169_4405)",
    strokeWidth: 0.541358,
    strokeDasharray: "10.83 10.83"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6169_4405",
    x1: 286.115,
    y1: 0.115234,
    x2: 286.115,
    y2: 671.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6169_4405",
    x1: 285.42,
    y1: 72.4385,
    x2: 285.42,
    y2: 598.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6169_4405",
    x1: 287.506,
    y1: 144.762,
    x2: 287.506,
    y2: 530.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6169_4405",
    x1: 275.684,
    y1: 204.567,
    x2: 275.684,
    y2: 466.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAA00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenBackground);
export default __webpack_public_path__ + "static/media/screenBackground.c498df761e0fb5bf85ef3f9513f92f62.svg";
export { ForwardRef as ReactComponent };